export default __webpack_public_path__ + "static/media/schalten-und-steuern.d5879917.webp";